<template>
  <div class="chat-assistant-rich text-sm leading-relaxed break-words">
    <template v-for="piece in pieces" :key="piece.key">
      <div
        v-if="piece.type === 'markdown' && piece.html"
        class="chat-md max-w-none"
        v-html="piece.html"
      />
      <ChatChartBlock
        v-else-if="piece.type === 'chart'"
        :spec="piece.spec"
        :chart-key="piece.key"
      />
    </template>
  </div>
</template>

<script>
import { splitChatAssistantContent } from '../utils/chatMessageSegments.js'
import { renderChatMarkdown } from '../utils/renderChatMarkdown.js'
import ChatChartBlock from './ChatChartBlock.vue'

export default {
  name: 'ChatAssistantBody',

  components: { ChatChartBlock },

  props: {
    content: {
      type: String,
      default: ''
    },
    messageId: {
      type: String,
      required: true
    }
  },

  computed: {
    pieces() {
      const id = this.messageId || 'm'
      return splitChatAssistantContent(this.content).map((seg, idx) => {
        const key = `${id}-${idx}`
        if (seg.type === 'chart') {
          return { type: 'chart', spec: seg.spec, key }
        }
        return {
          type: 'markdown',
          html: renderChatMarkdown(seg.content).trim(),
          key
        }
      })
    }
  }
}
</script>

<style scoped>
.chat-md :deep(p) {
  margin: 0.35em 0;
}
.chat-md :deep(p:first-child) {
  margin-top: 0;
}
.chat-md :deep(p:last-child) {
  margin-bottom: 0;
}
.chat-md :deep(ul),
.chat-md :deep(ol) {
  margin: 0.35em 0;
  padding-left: 1.25rem;
}
.chat-md :deep(li) {
  margin: 0.15em 0;
}
.chat-md :deep(table) {
  width: 100%;
  border-collapse: collapse;
  font-size: 0.8125rem;
  margin: 0.5rem 0;
}
.chat-md :deep(th),
.chat-md :deep(td) {
  border: 1px solid rgba(148, 163, 184, 0.4);
  padding: 0.35rem 0.5rem;
  text-align: left;
  vertical-align: top;
}
.chat-md :deep(th) {
  background: rgba(15, 23, 42, 0.75);
  color: #e2e8f0;
  font-weight: 600;
}
.chat-md :deep(tr:nth-child(even) td) {
  background: rgba(30, 41, 59, 0.35);
}
.chat-md :deep(pre) {
  margin: 0.5rem 0;
  padding: 0.6rem 0.75rem;
  border-radius: 0.5rem;
  background: rgba(15, 23, 42, 0.85);
  border: 1px solid rgba(71, 85, 105, 0.5);
  overflow-x: auto;
  font-size: 0.75rem;
}
.chat-md :deep(code) {
  font-size: 0.85em;
  padding: 0.1em 0.35em;
  border-radius: 0.25rem;
  background: rgba(15, 23, 42, 0.75);
}
.chat-md :deep(pre code) {
  padding: 0;
  background: transparent;
}
.chat-md :deep(blockquote) {
  margin: 0.5rem 0;
  padding-left: 0.75rem;
  border-left: 3px solid rgba(34, 211, 238, 0.45);
  color: #cbd5e1;
}
.chat-md :deep(a) {
  color: #67e8f9;
  text-decoration: underline;
  text-underline-offset: 2px;
}
.chat-md :deep(h1),
.chat-md :deep(h2),
.chat-md :deep(h3) {
  font-weight: 600;
  margin: 0.6rem 0 0.35rem;
  color: #f1f5f9;
}
.chat-md :deep(h1) {
  font-size: 1.05rem;
}
.chat-md :deep(h2) {
  font-size: 1rem;
}
.chat-md :deep(h3) {
  font-size: 0.95rem;
}
.chat-md :deep(hr) {
  margin: 0.65rem 0;
  border: none;
  border-top: 1px solid rgba(100, 116, 139, 0.45);
}
</style>
